module.exports = __webpack_public_path__ + "img/banner-empty.53e45f74.png";